<template><div><h3>Timeline_COM</h3>
<img width="100" src="http://qr.topscan.com/api.php?text=https%3A%2F%2Fvux.li%2Fdemos%2Fv2%2F%23%2Fcomponent%2Ftimeline"/>
<p><a href="https://vux.li/demos/v2/#/component/timeline" target="_blank" style="font-size:12px;color:#888;">demo 原始链接：https://vux.li/demos/v2/#/component/timeline</a></p>
<hr>
<h4>演示</h4>
 <div style="width:377px;height:667px;display:inline-block;border:1px dashed #ececec;border-radius:5px;overflow:hidden;">
   <iframe src="https://vux.li/demos/v2/#/component/timeline" width="375" height="667" border="0" frameborder="0"></iframe>
 </div>
<h4>demo 代码</h4>
<p class="tip">下面的$t是Demo的i18n使用的翻译函数，一般情况下可以直接使用字符串。另外，下面代码隐藏了i18n标签部分的代码。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
	<span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"timeline-demo"</span>&gt;</span>
		<span class="hljs-tag">&lt;<span class="hljs-name">timeline</span>&gt;</span>
			<span class="hljs-tag">&lt;<span class="hljs-name">timeline-item</span>&gt;</span>
				<span class="hljs-tag">&lt;<span class="hljs-name">h4</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"recent"</span>&gt;</span>【广东】 广州市 已发出<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
				<span class="hljs-tag">&lt;<span class="hljs-name">p</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"recent"</span>&gt;</span>2016-04-17 12:00:00<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
			<span class="hljs-tag">&lt;/<span class="hljs-name">timeline-item</span>&gt;</span>
			<span class="hljs-tag">&lt;<span class="hljs-name">timeline-item</span>&gt;</span>
				<span class="hljs-tag">&lt;<span class="hljs-name">h4</span>&gt;</span> 申通快递员 广东广州 收件员 xxx 已揽件<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
				<span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>2016-04-16 10:23:00<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
			<span class="hljs-tag">&lt;/<span class="hljs-name">timeline-item</span>&gt;</span>
			<span class="hljs-tag">&lt;<span class="hljs-name">timeline-item</span>&gt;</span>
				<span class="hljs-tag">&lt;<span class="hljs-name">h4</span>&gt;</span> 商家正在通知快递公司揽件<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
				<span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>2016-04-15 9:00:00<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
			<span class="hljs-tag">&lt;/<span class="hljs-name">timeline-item</span>&gt;</span>
		<span class="hljs-tag">&lt;/<span class="hljs-name">timeline</span>&gt;</span>
		<span class="hljs-tag">&lt;<span class="hljs-name">timeline</span>&gt;</span>
			<span class="hljs-tag">&lt;<span class="hljs-name">timeline-item</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">"(i, index) in count"</span> <span class="hljs-attr">:key</span>=<span class="hljs-string">"index"</span>&gt;</span>
				<span class="hljs-tag">&lt;<span class="hljs-name">h4</span> <span class="hljs-attr">:class</span>=<span class="hljs-string">"[i === 0 ? 'recent' : '']"</span>&gt;</span>Timeline Node <span>{{</span>i + 1<span>}}</span><span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
				<span class="hljs-tag">&lt;<span class="hljs-name">p</span> <span class="hljs-attr">:class</span>=<span class="hljs-string">"[i === 0 ? 'recent' : '']"</span>&gt;</span>index <span>{{</span>i + 1<span>}}</span><span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
			<span class="hljs-tag">&lt;/<span class="hljs-name">timeline-item</span>&gt;</span>
		<span class="hljs-tag">&lt;/<span class="hljs-name">timeline</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">x-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"count = 6"</span>&gt;</span> Set to 6 nodes<span class="hljs-tag">&lt;/<span class="hljs-name">x-button</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">x-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"count = 3"</span>&gt;</span> Set to 3 nodes<span class="hljs-tag">&lt;/<span class="hljs-name">x-button</span>&gt;</span>
	<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">import</span> { Timeline, TimelineItem, XButton } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">components</span>: {
    Timeline,
    TimelineItem,
    XButton
  },
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">count</span>: <span class="hljs-number">3</span>
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">style</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"less"</span>&gt;</span><span class="undefined">
.timeline-demo {
	p {
		color: #888;
		font-size: 0.8rem;
	}
	h4 {
		color: #666;
		font-weight: normal;
	}
	.recent {
		color: rgb(4, 190, 2)
	}
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>

</code></pre>
<h4>Github Issue</h4>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// timeline-414.vue?4869fcbc